const shopHasFeature = (masterConfig, feature_name) => {
  return masterConfig?.feature_matrix.includes(feature_name);
};

export { shopHasFeature };
